import { render } from "./environment-banner.vue?vue&type=template&id=98b91b5a"
import script from "./environment-banner.vue?vue&type=script&lang=js"
export * from "./environment-banner.vue?vue&type=script&lang=js"

import "./environment-banner.vue?vue&type=style&index=0&id=98b91b5a&lang=scss"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__